import { httpClient } from '../../../_helpers/http-client';

function init(el) {
    const form = el.querySelector('form');

    if (!form) {
        return;
    }

    form.addEventListener('submit', e => {
        e.preventDefault();

        form.querySelector('button[type="submit"]').disabled = true;

        httpClient.post(el.dataset.productReviews, new FormData(form)).then(response => {
            el.innerHTML = response.data;
            init(el);
        });
    });
}

document.addEventListener('DOMContentLoaded', () => {
    const el = document.querySelector('[data-product-reviews]');

    if (!el) {
        return;
    }

    httpClient.get(el.dataset.productReviews).then(response => {
        el.innerHTML = response.data;
        init(el);
    })
});
